var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _ellipse2, _ellipse3, _path52, _path53, _ellipse4, _ellipse5, _path54, _path55, _rect4, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _rect5, _rect6, _path67, _path68, _path69, _ellipse6, _path70, _path71, _path72, _path73, _rect7, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect8, _rect9, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _ellipse7, _ellipse8, _path102, _path103, _ellipse9, _ellipse10, _path104, _path105, _rect10, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _rect11, _rect12, _path117, _path118, _path119, _path120, _path121, _path122, _ellipse11, _path123, _path124, _path125, _path126, _rect13, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _rect14, _rect15, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _ellipse12, _ellipse13, _path162, _path163, _ellipse14, _ellipse15, _path164, _path165, _rect16, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _rect17, _rect18, _path177, _path178, _path179, _path180, _path181, _path182, _ellipse16, _path183, _path184, _path185, _path186, _rect19, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _rect20, _rect21, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _ellipse17, _ellipse18, _path222, _path223, _ellipse19, _ellipse20, _path224, _path225, _rect22, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _rect23, _rect24, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _ellipse21, _rect25, _rect26, _path244, _path245, _path246, _rect27, _rect28, _rect29, _path247, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path248, _path249, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _path250, _path251, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _path252, _path253, _path254, _path255, _path256, _path257, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 937,
    viewBox: "0 0 1512 937",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_396_2844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015 897.321C2012.11 896.734 2009.18 896.565 2006.2 896.848C1997.99 897.627 1989.78 897.473 1981.57 896.386C1972.35 895.166 1963.15 895.974 1954.01 898.774C1945.1 901.501 1936.25 905.409 1927.43 910.474C1919.51 915.026 1911.8 917.005 1904.24 916.65C1897.12 916.317 1889.54 912.749 1881.48 905.065C1876.77 900.575 1871.66 897.629 1866.17 896.87C1860.58 896.1 1855.21 897.67 1850.2 901.058C1842.45 906.308 1835.1 907.943 1827.94 906.544C1818.63 904.725 1809.32 905.291 1800.07 908.205C1792.14 910.706 1784.26 911.381 1776.41 910.271C1767.36 908.992 1758.31 909.217 1749.28 910.942C1741.96 912.34 1734.52 910.932 1726.77 906.339C1716.88 900.476 1706.63 900.236 1696.65 905.732C1688.97 909.966 1681.56 911.044 1674.23 909.281C1665.56 907.197 1656.88 905.491 1648.21 904.164C1639.95 902.902 1631.68 900.79 1623.39 897.819C1613.24 894.183 1603.17 896.093 1593.64 902.803C1585.63 908.435 1577.89 911.262 1570.36 911.62C1562.95 911.973 1555.33 909.715 1547.42 904.457C1542.51 901.201 1537.32 899.488 1531.93 899.697C1526.55 899.906 1521.42 902.007 1516.59 905.586C1509.11 911.137 1502.25 912 1495.41 909.049C1485.58 904.805 1475.61 905.255 1465.91 910.256C1457.83 914.421 1449.86 916.761 1441.98 917.37C1433.67 918.012 1425.36 917.992 1417.04 917.308C1409.05 916.65 1400.99 914.526 1392.86 910.887C1384.2 907.008 1375.53 903.551 1366.86 900.517C1356.51 896.895 1346.36 899.499 1336.9 907.149C1329.21 913.365 1322.19 914.845 1315.41 912.739C1306.83 910.075 1298.25 907.501 1289.68 905.017C1280.16 902.261 1270.61 902.708 1261.18 906.295C1253.01 909.398 1244.9 911.211 1236.82 911.763C1228.05 912.362 1219.29 913.597 1210.54 915.467C1203.61 916.947 1196.39 915.099 1188.61 908.979C1183.79 905.191 1178.63 902.936 1173.19 902.711C1167.72 902.485 1162.49 904.326 1157.58 907.776C1153.92 910.357 1150.57 911.391 1147.46 911.315C1144.34 911.239 1140.95 910.032 1137.23 907.236C1127.75 900.099 1117.67 897.785 1107.44 901.226C1100.07 903.705 1092.73 903.21 1085.18 899.571C1075.14 894.734 1064.95 895.539 1055.19 901.627C1047.16 906.639 1039.31 909.317 1031.61 909.861C1022.71 910.491 1013.82 912.161 1004.96 914.863C998.065 916.967 990.983 915.599 983.327 909.851C974.391 903.141 965.293 898.581 956.036 896.335C946.3 893.973 936.623 895.448 927.205 900.478C919.386 904.654 911.789 906.099 904.295 905.057C896.169 903.927 888.003 901.622 879.792 898.116C869.967 893.922 860.02 894.375 850.326 899.333C842.67 903.249 835.254 904.114 827.871 902.169C818.093 899.593 808.368 901.032 798.921 906.183C791.329 910.322 784.026 911.126 776.743 908.896C767.16 905.96 757.538 906.49 748.06 910.398C739.909 913.759 731.817 915.74 723.77 916.377C715.391 917.04 707.013 917.222 698.636 916.922C691.492 916.666 683.919 913.244 675.875 905.829C666.615 897.294 656.583 893.513 646.116 896.046C637.806 898.057 629.507 899.345 621.217 899.914C613.327 900.455 605.401 899.309 597.402 896.424C588.189 893.1 578.887 892.101 569.562 893.49C560.763 894.801 551.976 896.862 543.204 899.668C534.825 902.348 526.455 904.474 518.093 906.047C510.774 907.423 503.328 905.996 495.576 901.385C486.404 895.928 477.005 893.251 467.453 893.615C458.471 893.958 449.513 895.582 440.591 898.467C432.008 901.242 423.425 904.127 414.843 907.121C406.87 909.903 398.968 910.897 391.097 910.156C381.991 909.299 372.897 910.115 363.842 912.583C355.569 914.838 347.313 916.242 339.07 916.803C332.234 917.267 324.868 914.251 316.862 906.466C312.131 901.865 306.94 898.905 301.298 898.403C295.584 897.896 290.197 899.978 285.275 903.89C277.625 909.969 270.633 911.328 263.845 909.071C255.251 906.214 246.656 903.504 238.062 900.939C228.008 897.94 218.076 899.965 208.604 906.369C204.909 908.868 201.482 909.961 198.261 909.989C195.043 910.017 191.629 908.987 187.95 906.563C178.15 900.108 167.869 899.275 157.763 904.485C154.168 906.339 150.763 906.997 147.457 906.66C144.124 906.32 140.582 904.936 136.803 902.217C127.304 895.382 117.263 893.264 107.097 896.666C98.1579 899.658 89.2771 903.985 80.4551 909.611C73.0094 914.36 66.0043 915.022 58.958 912.082C50.3428 908.488 41.7254 905.131 33.1064 902.013C24.2794 898.819 15.4266 896.592 6.55273 895.343C-2.54559 894.062 -11.6452 894.453 -20.7188 896.507C-28.8144 898.34 -36.8868 898.871 -44.9531 898.111C-53.5179 897.304 -62.0827 896.54 -70.6475 895.819C-80.0918 895.025 -89.4496 896.949 -98.6475 901.435C-106.75 905.386 -114.76 907.653 -122.695 908.308C-131.348 909.021 -139.999 910.033 -148.648 911.342C-157.151 912.629 -165.653 913.777 -174.155 914.785C-181.847 915.697 -189.596 914.495 -197.477 911.06C-206.678 907.049 -216.008 905.482 -225.397 906.474C-234.221 907.405 -243.032 909.149 -251.828 911.698C-259.229 913.843 -266.632 913.156 -274.254 909.441C-283.259 905.053 -292.36 902.474 -301.535 901.779C-310.952 901.067 -320.286 902.982 -329.47 907.384C-332.033 908.612 -335.193 909.379 -339 909.613V632H2015V897.321Z",
    fill: "url(#paint0_linear_396_2844)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605.69 675.077C605.69 709.641 668.002 709.641 668.002 675.077V637.371H-328.995V675.077C-328.995 709.641 -266.683 709.641 -266.683 675.077C-266.683 709.641 -204.37 709.641 -204.37 675.077C-204.37 709.641 -142.058 709.641 -142.058 675.077C-142.058 709.641 -79.7457 709.641 -79.7457 675.077C-79.7457 709.641 -17.4334 709.641 -17.4334 675.077C-17.4334 709.641 44.879 709.641 44.879 675.077C44.879 709.641 107.191 709.641 107.191 675.077C107.191 709.641 169.504 709.641 169.504 675.077C169.504 709.641 231.816 709.641 231.816 675.077C231.816 709.641 294.128 709.641 294.128 675.077C294.128 709.641 356.441 709.641 356.441 675.077C356.441 709.641 418.753 709.641 418.753 675.077C418.753 709.641 481.065 709.641 481.065 675.077C481.065 709.641 543.378 709.641 543.378 675.077C543.378 709.641 605.69 709.641 605.69 675.077Z",
    fill: "#356D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1599.88 674.696C1599.88 709.768 1662 709.768 1662 674.696V636.435H668.002V674.696C668.002 709.768 730.127 709.768 730.127 674.696C730.127 709.768 792.252 709.768 792.252 674.696C792.252 709.768 854.377 709.768 854.377 674.696C854.377 709.768 916.502 709.768 916.502 674.696C916.502 709.768 978.627 709.768 978.627 674.696C978.627 709.768 1040.75 709.768 1040.75 674.696C1040.75 709.768 1102.88 709.768 1102.88 674.696C1102.88 709.768 1165 709.768 1165 674.696C1165 709.768 1227.13 709.768 1227.13 674.696C1227.13 709.768 1289.25 709.768 1289.25 674.696C1289.25 709.768 1351.38 709.768 1351.38 674.696C1351.38 709.768 1413.5 709.768 1413.5 674.696C1413.5 709.768 1475.63 709.768 1475.63 674.696C1475.63 709.768 1537.75 709.768 1537.75 674.696C1537.75 709.768 1599.88 709.768 1599.88 674.696Z",
    fill: "#356D04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M605.69 669.082C605.69 704.154 668.002 704.154 668.002 669.082V630.821H-328.995V669.082C-328.995 704.154 -266.683 704.154 -266.683 669.082C-266.683 704.154 -204.37 704.154 -204.37 669.082C-204.37 704.154 -142.058 704.154 -142.058 669.082C-142.058 704.154 -79.7457 704.154 -79.7457 669.082C-79.7457 704.154 -17.4334 704.154 -17.4334 669.082C-17.4334 704.154 44.879 704.154 44.879 669.082C44.879 704.154 107.191 704.154 107.191 669.082C107.191 704.154 169.504 704.154 169.504 669.082C169.504 704.154 231.816 704.154 231.816 669.082C231.816 704.154 294.128 704.154 294.128 669.082C294.128 704.154 356.441 704.154 356.441 669.082C356.441 704.154 418.753 704.154 418.753 669.082C418.753 704.154 481.065 704.154 481.065 669.082C481.065 704.154 543.378 704.154 543.378 669.082C543.378 704.154 605.69 704.154 605.69 669.082Z",
    fill: "#5DB44D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1599.88 669.082C1599.88 704.154 1662 704.154 1662 669.082V630.821H668.002V669.082C668.002 704.154 730.127 704.154 730.127 669.082C730.127 704.154 792.252 704.154 792.252 669.082C792.252 704.154 854.377 704.154 854.377 669.082C854.377 704.154 916.502 704.154 916.502 669.082C916.502 704.154 978.627 704.154 978.627 669.082C978.627 704.154 1040.75 704.154 1040.75 669.082C1040.75 704.154 1102.88 704.154 1102.88 669.082C1102.88 704.154 1165 704.154 1165 669.082C1165 704.154 1227.13 704.154 1227.13 669.082C1227.13 704.154 1289.25 704.154 1289.25 669.082C1289.25 704.154 1351.38 704.154 1351.38 669.082C1351.38 704.154 1413.5 704.154 1413.5 669.082C1413.5 704.154 1475.63 704.154 1475.63 669.082C1475.63 704.154 1537.75 704.154 1537.75 669.082C1537.75 704.154 1599.88 704.154 1599.88 669.082Z",
    fill: "#5DB44D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M605.685 659.27C605.685 689.768 667.998 689.768 667.998 659.27V626H-329V659.27C-329 689.768 -266.688 689.768 -266.688 659.27C-266.688 689.768 -204.375 689.768 -204.375 659.27C-204.375 689.768 -142.063 689.768 -142.063 659.27C-142.063 689.768 -79.7506 689.768 -79.7506 659.27C-79.7506 689.768 -17.4383 689.768 -17.4383 659.27C-17.4383 689.768 44.8741 689.768 44.8741 659.27C44.8741 689.768 107.186 689.768 107.186 659.27C107.186 689.768 169.499 689.768 169.499 659.27C169.499 689.768 231.811 689.768 231.811 659.27C231.811 689.768 294.123 689.768 294.123 659.27C294.123 689.768 356.436 689.768 356.436 659.27C356.436 689.768 418.748 689.768 418.748 659.27C418.748 689.768 481.061 689.768 481.061 659.27C481.061 689.768 543.373 689.768 543.373 659.27C543.373 689.768 605.685 689.768 605.685 659.27Z",
    fill: "url(#paint1_linear_396_2844)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1599.87 660.206C1599.87 690.703 1662 690.703 1662 660.206V626.936H667.998V660.206C667.998 690.703 730.122 690.703 730.122 660.206C730.122 690.703 792.247 690.703 792.247 660.206C792.247 690.703 854.372 690.703 854.372 660.206C854.372 690.703 916.497 690.703 916.497 660.206C916.497 690.703 978.622 690.703 978.622 660.206C978.622 690.703 1040.75 690.703 1040.75 660.206C1040.75 690.703 1102.87 690.703 1102.87 660.206C1102.87 690.703 1165 690.703 1165 660.206C1165 690.703 1227.12 690.703 1227.12 660.206C1227.12 690.703 1289.25 690.703 1289.25 660.206C1289.25 690.703 1351.37 690.703 1351.37 660.206C1351.37 690.703 1413.5 690.703 1413.5 660.206C1413.5 690.703 1475.62 690.703 1475.62 660.206C1475.62 690.703 1537.75 690.703 1537.75 660.206C1537.75 690.703 1599.87 690.703 1599.87 660.206Z",
    fill: "url(#paint2_linear_396_2844)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.066 632.996L206.648 498.291H303.874V632.996H204.066Z",
    fill: "#E5BDAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M503.49 428.355H422.181L420.46 632.201H497.037C497.037 632.201 498.343 607.264 498.757 591.273C499.425 565.521 498.249 551.066 498.757 525.311C499.505 487.415 503.49 428.355 503.49 428.355Z",
    fill: "#E5BDAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.067 444.25L198.904 498.291H301.724L300.003 444.25H204.067Z",
    fill: "#EE5252"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M518.117 331.399H393.357L415.728 431.931H512.524L518.117 331.399Z",
    fill: "#EE5252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M295.271 408.09C302.84 490.493 303.373 540.853 298.712 636.969H423.042C420.165 548.488 421.943 499.332 428.204 412.063L359.371 265.04L295.271 408.09Z",
    fill: "#EFE8DE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.661,
    cy: 362.393,
    rx: 17.2082,
    ry: 15.8944,
    fill: "#8F5959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M477.247 492.33H441.54L447.563 392.99L466.492 358.022L481.979 391.798L477.247 492.33Z",
    fill: "#EFE8DE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M447.564 394.579L443.262 392.99L466.063 352.062L487.573 392.99L483.271 395.771L466.063 360.009L447.564 394.579Z",
    fill: "#C22338"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M400.671 261.464C401.132 289.524 400.874 305.32 398.09 333.783L403.683 344.91C407.246 312.312 407.961 294.042 407.555 261.464C409.194 259.813 410.502 259.623 413.147 259.874V252.324H395.509V261.464C397.981 260.718 399.095 260.737 400.671 261.464Z",
    fill: "#C2504D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.806 430.342L279.353 424.779L359.371 251.927L442.831 427.163L435.947 429.945L359.371 265.437L285.806 430.342Z",
    fill: "#C22326"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.977,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 445.26 515.775)",
    fill: "#C6B2A5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M475.527 596.041C461.404 594.979 453.854 594.977 441.11 596.041C442.275 562.367 442.983 543.488 441.11 509.814C454.551 510.628 462.086 510.587 475.527 509.814C472.989 544.143 472.766 562.983 475.527 596.041Z",
    fill: "#B1535C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M447.133 575.378V563.855H456.598V575.378H447.133Z",
    fill: "#EFF7FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M458.319 547.166V561.073L467.353 561.471L466.923 547.166H458.319Z",
    fill: "#EFF7FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M447.133 532.463V545.179L456.168 544.782L456.598 532.463H447.133Z",
    fill: "#EFF7FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M458.319 516.172L459.179 530.477H468.213V516.172H458.319Z",
    fill: "#EFF7FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M458.319 590.081V577.365L468.644 577.763V590.081H458.319Z",
    fill: "#EFF7FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M458.319 563.458V575.378L467.783 575.776L467.353 563.855L458.319 563.458Z",
    fill: "#EFF7FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M456.598 590.478V577.763H447.133V590.478H456.598Z",
    fill: "#EFF7FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M447.133 561.073L456.598 561.471L456.168 546.371L446.703 546.768L447.133 561.073Z",
    fill: "#EFF7FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.319 532.861V545.179L467.783 545.576V532.861H458.319Z",
    fill: "#EFF7FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M446.703 530.874H456.598L456.168 516.569H447.133L446.703 530.874Z",
    fill: "#EFF7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 339.582,
    y: 521.735,
    width: 41.2998,
    height: 91.393,
    fill: "#75262F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9288,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 453.296 404.394)",
    fill: "#59544E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M473.811 481.838C464.144 482.321 458.879 482.274 449.83 481.53C450.29 441.17 450.553 424.072 451.032 401.734C460.229 402.679 465.479 402.748 475.013 402.042C472.596 433.596 472.466 451.045 473.811 481.838Z",
    fill: "#B1535C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M454.315 462.462L454.475 451.798L461.07 451.883L460.909 462.547L454.315 462.462Z",
    fill: "#EFF7FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M462.502 436.454L462.308 449.324L468.597 449.773L468.497 436.531L462.502 436.454Z",
    fill: "#EFF7FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M454.913 422.748L454.735 434.515L461.036 434.228L461.507 422.833L454.913 422.748Z",
    fill: "#EFF7FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M462.933 407.771L463.334 421.017L469.629 421.098L469.828 407.86L462.933 407.771Z",
    fill: "#EFF7FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M461.904 476.168L462.081 464.401L469.27 464.861L469.098 476.26L461.904 476.168Z",
    fill: "#EFF7FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M462.275 451.53L462.108 462.562L468.698 463.015L468.564 451.979L462.275 451.53Z",
    fill: "#EFF7FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M460.699 476.52L460.876 464.753L454.281 464.668L454.104 476.436L460.699 476.52Z",
    fill: "#EFF7FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M454.514 449.224L461.103 449.676L461.014 435.699L454.413 435.982L454.514 449.224Z",
    fill: "#EFF7FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M462.701 423.216L462.529 434.615L469.118 435.068L469.296 423.3L462.701 423.216Z",
    fill: "#EFF7FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M454.635 421.273L461.53 421.362L461.429 408.12L455.134 408.039L454.635 421.273Z",
    fill: "#EFF7FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M222.136 527.298V632.996H286.667V527.298C261.858 521.171 247.722 521.271 222.136 527.298Z",
    fill: "#83131E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M227.729 532.861V534.848H243.216V530.477C237.178 530.542 233.791 530.918 227.729 532.861Z",
    fill: "#EFF7FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M266.017 530.477V534.848H281.504V532.861C276.398 530.963 272.978 530.471 266.017 530.477Z",
    fill: "#EFF7FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M263.436 534.848H245.797V530.477C252.797 529.04 256.652 529.097 263.436 530.477V534.848Z",
    fill: "#EFF7FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M227.729 542H243.216V536.437H227.729V542Z",
    fill: "#EFF7FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M245.797 536.437V542H263.436V536.437H245.797Z",
    fill: "#EFF7FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M266.017 536.437V542H281.504V536.437H266.017Z",
    fill: "#EFF7FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M331.838 613.128V621.075H388.625V613.128H331.838Z",
    fill: "url(#paint3_linear_396_2844)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M324.31 619.486V628.228H395.724V619.486H324.31Z",
    fill: "url(#paint4_linear_396_2844)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M317.211 626.638V633.393H401.962V626.638H317.211Z",
    fill: "url(#paint5_linear_396_2844)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M312.479 633.393V639.751H406.263V633.393H312.479Z",
    fill: "url(#paint6_linear_396_2844)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327.536 524.914C327.1 522.39 325.689 521.479 322.373 518.158H398.089C394.121 520.222 392.625 521.732 392.066 524.914H327.536Z",
    fill: "#61000F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M388.626 605.975H380.021L382.173 613.128H386.475L388.626 605.975Z",
    fill: "#E6B5A1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M385.495 533.656H382.85C381.381 559.481 381.365 574.1 382.85 600.412H385.495C387.366 574.341 387.383 559.719 385.495 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.323,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.323,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M340.442 605.975H331.838L333.989 613.128H338.291L340.442 605.975Z",
    fill: "#E6B5A1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M337.311 533.656H334.666C333.197 559.481 333.181 574.1 334.666 600.412H337.311C339.182 574.341 339.2 559.719 337.311 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.14,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.14,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M338.291 473.654C340.655 477.165 341.424 479.419 341.733 483.986H378.3C379.037 479.151 379.66 476.656 382.172 473.654H338.291Z",
    fill: "#A82E38"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M399.81 518.158H320.652C328.343 507.646 332.063 501.738 336.14 491.138H383.032C387.313 501.849 391.639 507.719 399.81 518.158Z",
    fill: "#B7323D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 347.756,
    y: 393.387,
    width: 26.6728,
    height: 77.8827,
    fill: "#59544E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M343.023 475.244C356.884 475.899 364.44 475.922 377.44 475.244C377.652 431.633 377.643 413.156 377.44 389.016C364.222 389.91 356.687 389.912 343.023 389.016C345.809 423.141 345.619 441.994 343.023 475.244Z",
    fill: "#B1535C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M371.416 454.581V443.058H361.952V454.581H371.416Z",
    fill: "#EFF7FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M360.231 426.368V440.276L351.197 440.673L351.627 426.368H360.231Z",
    fill: "#EFF7FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M371.416 411.666V424.382L362.382 423.984L361.952 411.666H371.416Z",
    fill: "#EFF7FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M360.231 395.374L359.371 409.679H350.336V395.374H360.231Z",
    fill: "#EFF7FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M360.231 469.283V456.568L349.906 456.965V469.283H360.231Z",
    fill: "#EFF7FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M360.231 442.66V454.581L350.767 454.978L351.197 443.058L360.231 442.66Z",
    fill: "#EFF7FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M361.952 469.681V456.965H371.416V469.681H361.952Z",
    fill: "#EFF7FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M371.416 440.276L361.952 440.673L362.382 425.574L371.847 425.971L371.416 440.276Z",
    fill: "#EFF7FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M360.231 412.063V424.382L350.767 424.779V412.063H360.231Z",
    fill: "#EFF7FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M371.847 410.077H361.952L362.382 395.772H371.416L371.847 410.077Z",
    fill: "#EFF7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 346.895,
    y: 565.842,
    width: 25.8124,
    height: 43.7097,
    fill: "#5D2022"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 346.895,
    y: 525.311,
    width: 25.8124,
    height: 32.5836,
    fill: "#5D2022"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M196.741 428.355H115.432L113.711 632.201H190.288C190.288 632.201 191.594 607.264 192.008 591.273C192.676 565.521 191.5 551.066 192.008 525.311C192.756 487.415 196.741 428.355 196.741 428.355Z",
    fill: "#E5BDAC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M211.368 331.399H86.6084L108.979 431.931H205.775L211.368 331.399Z",
    fill: "#EE5252"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.4785 408.09C-3.90951 490.493 -3.37613 540.853 -8.03687 636.969H116.293C113.416 548.488 115.194 499.332 121.455 412.063L52.6222 265.04L-11.4785 408.09Z",
    fill: "#EFE8DE"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.9123,
    cy: 362.393,
    rx: 17.2082,
    ry: 15.8944,
    fill: "#8F5959"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M170.498 492.33H134.791L140.814 392.99L159.743 358.022L175.23 391.798L170.498 492.33Z",
    fill: "#EFE8DE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M140.815 394.579L136.513 392.99L159.314 352.062L180.824 392.99L176.522 395.771L159.314 360.009L140.815 394.579Z",
    fill: "#C22338"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9222 261.464C94.3832 289.524 94.1254 305.32 91.341 333.783L96.9337 344.91C100.497 312.312 101.212 294.042 100.806 261.464C102.445 259.813 103.753 259.623 106.398 259.874V252.324H88.7598V261.464C91.2318 260.718 92.3465 260.737 93.9222 261.464Z",
    fill: "#C2504D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.9434 430.342L-27.3965 424.779L52.6218 251.927L136.082 427.163L129.198 429.945L52.6218 265.437L-20.9434 430.342Z",
    fill: "#C22326"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 25.977,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 138.511 515.775)",
    fill: "#C6B2A5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M168.778 596.041C154.655 594.979 147.105 594.977 134.361 596.041C135.526 562.367 136.234 543.488 134.361 509.814C147.802 510.628 155.337 510.587 168.778 509.814C166.24 544.143 166.017 562.983 168.778 596.041Z",
    fill: "#B1535C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M140.384 575.378V563.855H149.849V575.378H140.384Z",
    fill: "#EFF7FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 547.166V561.073L160.604 561.471L160.174 547.166H151.57Z",
    fill: "#EFF7FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M140.384 532.463V545.179L149.419 544.782L149.849 532.463H140.384Z",
    fill: "#EFF7FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 516.172L152.43 530.477H161.464V516.172H151.57Z",
    fill: "#EFF7FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 590.081V577.365L161.895 577.763V590.081H151.57Z",
    fill: "#EFF7FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 563.458V575.378L161.034 575.776L160.604 563.855L151.57 563.458Z",
    fill: "#EFF7FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M149.849 590.478V577.763H140.384V590.478H149.849Z",
    fill: "#EFF7FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M140.384 561.073L149.849 561.471L149.419 546.371L139.954 546.768L140.384 561.073Z",
    fill: "#EFF7FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.57 532.861V545.179L161.034 545.576V532.861H151.57Z",
    fill: "#EFF7FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M139.954 530.874H149.849L149.419 516.569H140.384L139.954 530.874Z",
    fill: "#EFF7FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32.833,
    y: 521.735,
    width: 41.2998,
    height: 91.393,
    fill: "#75262F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9288,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 146.547 404.394)",
    fill: "#59544E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M167.062 481.838C157.395 482.321 152.13 482.274 143.081 481.53C143.541 441.17 143.804 424.072 144.283 401.734C153.48 402.679 158.73 402.748 168.264 402.042C165.847 433.596 165.717 451.045 167.062 481.838Z",
    fill: "#B1535C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M147.566 462.462L147.726 451.798L154.321 451.883L154.16 462.547L147.566 462.462Z",
    fill: "#EFF7FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M155.753 436.454L155.559 449.324L161.848 449.773L161.748 436.531L155.753 436.454Z",
    fill: "#EFF7FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M148.164 422.748L147.986 434.515L154.287 434.228L154.758 422.833L148.164 422.748Z",
    fill: "#EFF7FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M156.184 407.771L156.585 421.017L162.88 421.098L163.079 407.86L156.184 407.771Z",
    fill: "#EFF7FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M155.155 476.168L155.332 464.401L162.52 464.861L162.349 476.26L155.155 476.168Z",
    fill: "#EFF7FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M155.526 451.53L155.359 462.562L161.949 463.015L161.815 451.979L155.526 451.53Z",
    fill: "#EFF7FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M153.95 476.52L154.127 464.753L147.532 464.668L147.355 476.436L153.95 476.52Z",
    fill: "#EFF7FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M147.765 449.224L154.354 449.676L154.265 435.699L147.664 435.982L147.765 449.224Z",
    fill: "#EFF7FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M155.952 423.216L155.78 434.615L162.369 435.068L162.547 423.3L155.952 423.216Z",
    fill: "#EFF7FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.886 421.273L154.78 421.362L154.68 408.12L148.385 408.039L147.886 421.273Z",
    fill: "#EFF7FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0889 613.128V621.075H81.8761V613.128H25.0889Z",
    fill: "url(#paint7_linear_396_2844)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 619.486V628.228H88.9747V619.486H17.5605Z",
    fill: "url(#paint8_linear_396_2844)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4619 626.638V633.393H95.2125V626.638H10.4619Z",
    fill: "url(#paint9_linear_396_2844)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7865 524.914C20.3513 522.39 18.9398 521.479 15.624 518.158H91.3403C87.3716 520.222 85.8756 521.732 85.3174 524.914H20.7865Z",
    fill: "#61000F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8756 605.975H73.2715L75.4225 613.128H79.7246L81.8756 605.975Z",
    fill: "#E6B5A1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7447 533.656H76.0997C74.6311 559.481 74.6149 574.1 76.0997 600.412H78.7447C80.6159 574.341 80.6334 559.719 78.7447 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.5735,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.5735,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.693 605.975H25.0889L27.2399 613.128H31.542L33.693 605.975Z",
    fill: "#E6B5A1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5621 533.656H27.9171C26.4485 559.481 26.4323 574.1 27.9171 600.412H30.5621C32.4333 574.341 32.4508 559.719 30.5621 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3909,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3909,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.542 473.654C33.9056 477.165 34.6746 479.419 34.9836 483.986H71.5511C72.2877 479.151 72.9108 476.656 75.423 473.654H31.542Z",
    fill: "#A82E38"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0612 518.158H13.9033C21.5944 507.646 25.3137 501.738 29.3907 491.138H76.2832C80.5643 501.849 84.8904 507.719 93.0612 518.158Z",
    fill: "#B7323D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0068,
    y: 393.387,
    width: 26.6728,
    height: 77.8827,
    fill: "#59544E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2741 475.244C50.1346 475.899 57.6911 475.922 70.6905 475.244C70.903 431.633 70.8944 413.156 70.6905 389.016C57.4731 389.91 49.9382 389.912 36.2741 389.016C39.06 423.141 38.87 441.994 36.2741 475.244Z",
    fill: "#B1535C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6675 454.581V443.058H55.2029V454.581H64.6675Z",
    fill: "#EFF7FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4821 426.368V440.276L44.4478 440.673L44.878 426.368H53.4821Z",
    fill: "#EFF7FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6675 411.666V424.382L55.6331 423.984L55.2029 411.666H64.6675Z",
    fill: "#EFF7FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4821 395.374L52.6217 409.679H43.5874V395.374H53.4821Z",
    fill: "#EFF7FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4821 469.283V456.568L43.1572 456.965V469.283H53.4821Z",
    fill: "#EFF7FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4821 442.66V454.581L44.0176 454.978L44.4478 443.058L53.4821 442.66Z",
    fill: "#EFF7FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2029 469.681V456.965H64.6675V469.681H55.2029Z",
    fill: "#EFF7FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6675 440.276L55.2029 440.673L55.6331 425.574L65.0977 425.971L64.6675 440.276Z",
    fill: "#EFF7FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4821 412.063V424.382L44.0176 424.779V412.063H53.4821Z",
    fill: "#EFF7FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0977 410.077H55.2029L55.6331 395.772H64.6675L65.0977 410.077Z",
    fill: "#EFF7FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1465,
    y: 565.842,
    width: 25.8124,
    height: 43.7097,
    fill: "#5D2022"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1465,
    y: 525.311,
    width: 25.8124,
    height: 32.5836,
    fill: "#5D2022"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72949 633.393V639.751H99.5144V633.393H5.72949Z",
    fill: "url(#paint10_linear_396_2844)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.03 632.996L1251.61 498.291H1348.84V632.996H1249.03Z",
    fill: "#E5BDAC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.45 428.355H1467.14L1465.42 632.201H1542C1542 632.201 1543.31 607.264 1543.72 591.273C1544.39 565.521 1543.21 551.066 1543.72 525.311C1544.47 487.415 1548.45 428.355 1548.45 428.355Z",
    fill: "#E5BDAC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1249.03 444.25L1243.87 498.291H1346.69L1344.97 444.25H1249.03Z",
    fill: "#EE5252"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1563.08 331.399H1438.32L1460.69 431.931H1557.49L1563.08 331.399Z",
    fill: "#EE5252"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.23 408.09C1347.8 490.493 1348.33 540.853 1343.67 636.969H1468C1465.13 548.488 1466.91 499.332 1473.17 412.063L1404.33 265.04L1340.23 408.09Z",
    fill: "#EFE8DE"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1405.62,
    cy: 362.393,
    rx: 17.2082,
    ry: 15.8944,
    fill: "#8F5959"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.21 492.33H1486.5L1492.53 392.99L1511.46 358.022L1526.94 391.798L1522.21 492.33Z",
    fill: "#EFE8DE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.53 394.579L1488.22 392.99L1511.03 352.062L1532.54 392.99L1528.23 395.771L1511.03 360.009L1492.53 394.579Z",
    fill: "#C22338"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.63 261.464C1446.09 289.524 1445.84 305.32 1443.05 333.783L1448.64 344.91C1452.21 312.312 1452.92 294.042 1452.52 261.464C1454.16 259.813 1455.46 259.623 1458.11 259.874V252.324H1440.47V261.464C1442.94 260.718 1444.06 260.737 1445.63 261.464Z",
    fill: "#C2504D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.77 430.342L1324.32 424.779L1404.33 251.927L1487.79 427.163L1480.91 429.945L1404.33 265.437L1330.77 430.342Z",
    fill: "#C22326"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 25.977,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 1490.22 515.775)",
    fill: "#C6B2A5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1520.49 596.041C1506.37 594.979 1498.82 594.977 1486.07 596.041C1487.24 562.367 1487.94 543.488 1486.07 509.814C1499.51 510.628 1507.05 510.587 1520.49 509.814C1517.95 544.143 1517.73 562.983 1520.49 596.041Z",
    fill: "#B1535C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.1 575.378V563.855H1501.56V575.378H1492.1Z",
    fill: "#EFF7FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.28 547.166V561.073L1512.32 561.471L1511.89 547.166H1503.28Z",
    fill: "#EFF7FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.1 532.463V545.179L1501.13 544.782L1501.56 532.463H1492.1Z",
    fill: "#EFF7FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.28 516.172L1504.14 530.477H1513.18V516.172H1503.28Z",
    fill: "#EFF7FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.28 590.081V577.365L1513.61 577.763V590.081H1503.28Z",
    fill: "#EFF7FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.28 563.458V575.378L1512.75 575.776L1512.32 563.855L1503.28 563.458Z",
    fill: "#EFF7FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.56 590.478V577.763H1492.1V590.478H1501.56Z",
    fill: "#EFF7FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1492.1 561.073L1501.56 561.471L1501.13 546.371L1491.67 546.768L1492.1 561.073Z",
    fill: "#EFF7FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1503.28 532.861V545.179L1512.75 545.576V532.861H1503.28Z",
    fill: "#EFF7FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1491.67 530.874H1501.56L1501.13 516.569H1492.1L1491.67 530.874Z",
    fill: "#EFF7FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1384.54,
    y: 521.735,
    width: 41.2998,
    height: 91.393,
    fill: "#75262F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9288,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 1498.26 404.394)",
    fill: "#59544E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.78 481.838C1509.11 482.321 1503.84 482.274 1494.79 481.53C1495.25 441.17 1495.52 424.072 1496 401.734C1505.19 402.679 1510.44 402.748 1519.98 402.042C1517.56 433.596 1517.43 451.045 1518.78 481.838Z",
    fill: "#B1535C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.28 462.462L1499.44 451.798L1506.03 451.883L1505.87 462.547L1499.28 462.462Z",
    fill: "#EFF7FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.46 436.454L1507.27 449.324L1513.56 449.773L1513.46 436.531L1507.46 436.454Z",
    fill: "#EFF7FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.88 422.748L1499.7 434.515L1506 434.228L1506.47 422.833L1499.88 422.748Z",
    fill: "#EFF7FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.9 407.771L1508.3 421.017L1514.59 421.098L1514.79 407.86L1507.9 407.771Z",
    fill: "#EFF7FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.87 476.168L1507.04 464.401L1514.23 464.861L1514.06 476.26L1506.87 476.168Z",
    fill: "#EFF7FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.24 451.53L1507.07 462.562L1513.66 463.015L1513.53 451.979L1507.24 451.53Z",
    fill: "#EFF7FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1505.66 476.52L1505.84 464.753L1499.24 464.668L1499.07 476.436L1505.66 476.52Z",
    fill: "#EFF7FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.48 449.224L1506.07 449.676L1505.98 435.699L1499.38 435.982L1499.48 449.224Z",
    fill: "#EFF7FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.66 423.216L1507.49 434.615L1514.08 435.068L1514.26 423.3L1507.66 423.216Z",
    fill: "#EFF7FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.6 421.273L1506.49 421.362L1506.39 408.12L1500.1 408.039L1499.6 421.273Z",
    fill: "#EFF7FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1267.1 527.298V632.996H1331.63V527.298C1306.82 521.171 1292.68 521.271 1267.1 527.298Z",
    fill: "#83131E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.69 532.861V534.848H1288.18V530.477C1282.14 530.542 1278.75 530.918 1272.69 532.861Z",
    fill: "#EFF7FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.98 530.477V534.848H1326.47V532.861C1321.36 530.963 1317.94 530.471 1310.98 530.477Z",
    fill: "#EFF7FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.4 534.848H1290.76V530.477C1297.76 529.04 1301.61 529.097 1308.4 530.477V534.848Z",
    fill: "#EFF7FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.69 542H1288.18V536.437H1272.69V542Z",
    fill: "#EFF7FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.76 536.437V542H1308.4V536.437H1290.76Z",
    fill: "#EFF7FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.98 536.437V542H1326.47V536.437H1310.98Z",
    fill: "#EFF7FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.8 613.128V621.075H1433.59V613.128H1376.8Z",
    fill: "url(#paint11_linear_396_2844)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.27 619.486V628.228H1440.69V619.486H1369.27Z",
    fill: "url(#paint12_linear_396_2844)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.17 626.638V633.393H1446.92V626.638H1362.17Z",
    fill: "url(#paint13_linear_396_2844)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.5 524.914C1372.06 522.39 1370.65 521.479 1367.34 518.158H1443.05C1439.08 520.222 1437.59 521.732 1437.03 524.914H1372.5Z",
    fill: "#61000F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.59 605.975H1424.98L1427.14 613.128H1431.44L1433.59 605.975Z",
    fill: "#E6B5A1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.46 533.656H1427.81C1426.34 559.481 1426.33 574.1 1427.81 600.412H1430.46C1432.33 574.341 1432.35 559.719 1430.46 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1429.29,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1429.29,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.4 605.975H1376.8L1378.95 613.128H1383.25L1385.4 605.975Z",
    fill: "#E6B5A1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.27 533.656H1379.63C1378.16 559.481 1378.14 574.1 1379.63 600.412H1382.27C1384.15 574.341 1384.16 559.719 1382.27 533.656Z",
    fill: "#E6B5A1"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1381.1,
    cy: 530.08,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1381.1,
    cy: 601.604,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.25 473.654C1385.62 477.165 1386.39 479.419 1386.7 483.986H1423.26C1424 479.151 1424.62 476.656 1427.13 473.654H1383.25Z",
    fill: "#A82E38"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.77 518.158H1365.62C1373.31 507.646 1377.03 501.738 1381.1 491.138H1428C1432.28 501.849 1436.6 507.719 1444.77 518.158Z",
    fill: "#B7323D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1392.72,
    y: 393.387,
    width: 26.6728,
    height: 77.8827,
    fill: "#59544E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.99 475.244C1401.85 475.899 1409.4 475.922 1422.4 475.244C1422.61 431.633 1422.61 413.156 1422.4 389.016C1409.19 389.91 1401.65 389.912 1387.99 389.016C1390.77 423.141 1390.58 441.994 1387.99 475.244Z",
    fill: "#B1535C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.38 454.581V443.058H1406.92V454.581H1416.38Z",
    fill: "#EFF7FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.19 426.368V440.276L1396.16 440.673L1396.59 426.368H1405.19Z",
    fill: "#EFF7FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.38 411.666V424.382L1407.35 423.984L1406.92 411.666H1416.38Z",
    fill: "#EFF7FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.19 395.374L1404.33 409.679H1395.3V395.374H1405.19Z",
    fill: "#EFF7FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.19 469.283V456.568L1394.87 456.965V469.283H1405.19Z",
    fill: "#EFF7FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.19 442.66V454.581L1395.73 454.978L1396.16 443.058L1405.19 442.66Z",
    fill: "#EFF7FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.92 469.681V456.965H1416.38V469.681H1406.92Z",
    fill: "#EFF7FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.38 440.276L1406.92 440.673L1407.35 425.574L1416.81 425.971L1416.38 440.276Z",
    fill: "#EFF7FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.19 412.063V424.382L1395.73 424.779V412.063H1405.19Z",
    fill: "#EFF7FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.81 410.077H1406.92L1407.35 395.772H1416.38L1416.81 410.077Z",
    fill: "#EFF7FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1391.86,
    y: 565.842,
    width: 25.8124,
    height: 43.7097,
    fill: "#5D2022"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1391.86,
    y: 525.311,
    width: 25.8124,
    height: 32.5836,
    fill: "#5D2022"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.44 633.393V639.751H1451.23V633.393H1357.44Z",
    fill: "url(#paint14_linear_396_2844)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M941.275 632.201L943.857 497.496H1041.08V632.201H941.275Z",
    fill: "#E5BDAC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.7 427.56H1159.39L1157.67 631.406H1234.25C1234.25 631.406 1235.55 606.469 1235.97 590.478C1236.64 564.726 1235.46 550.272 1235.97 524.516C1236.72 486.62 1240.7 427.56 1240.7 427.56Z",
    fill: "#E5BDAC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M941.276 443.455L936.113 497.496H1038.93L1037.21 443.455H941.276Z",
    fill: "#EE5252"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.33 330.604H1130.57L1152.94 431.137H1249.73L1255.33 330.604Z",
    fill: "#EE5252"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.48 407.295C1040.05 489.698 1040.58 540.058 1035.92 636.174H1160.25C1157.38 547.693 1159.15 498.537 1165.41 411.268L1096.58 264.245L1032.48 407.295Z",
    fill: "#EFE8DE"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1097.87,
    cy: 361.599,
    rx: 17.2082,
    ry: 15.8944,
    fill: "#8F5959"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.46 491.535H1178.75L1184.77 392.195L1203.7 357.228L1219.19 391.003L1214.46 491.535Z",
    fill: "#EFE8DE"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.77 393.784L1180.47 392.195L1203.27 351.267L1224.78 392.195L1220.48 394.977L1203.27 359.214L1184.77 393.784Z",
    fill: "#C22338"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.88 260.669C1138.34 288.729 1138.08 304.525 1135.3 332.988L1140.89 344.115C1144.45 311.518 1145.17 293.248 1144.76 260.669C1146.4 259.018 1147.71 258.828 1150.36 259.079V251.53H1132.72V260.669C1135.19 259.923 1136.3 259.942 1137.88 260.669Z",
    fill: "#C2504D"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.02 429.547L1016.56 423.984L1096.58 251.132L1180.04 426.368L1173.16 429.15L1096.58 264.643L1023.02 429.547Z",
    fill: "#C22326"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 25.977,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 1182.47 514.98)",
    fill: "#C6B2A5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.74 595.246C1198.61 594.184 1191.06 594.182 1178.32 595.246C1179.48 561.573 1180.19 542.693 1178.32 509.019C1191.76 509.834 1199.3 509.793 1212.74 509.019C1210.2 543.348 1209.98 562.189 1212.74 595.246Z",
    fill: "#B1535C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.34 574.584V563.06H1193.81V574.584H1184.34Z",
    fill: "#EFF7FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.53 546.371V560.279L1204.56 560.676L1204.13 546.371H1195.53Z",
    fill: "#EFF7FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.34 531.669V544.384L1193.38 543.987L1193.81 531.669H1184.34Z",
    fill: "#EFF7FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.53 515.377L1196.39 529.682H1205.42V515.377H1195.53Z",
    fill: "#EFF7FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.53 589.286V576.57L1205.85 576.968V589.286H1195.53Z",
    fill: "#EFF7FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.53 562.663V574.584L1204.99 574.981L1204.56 563.06L1195.53 562.663Z",
    fill: "#EFF7FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.81 589.683V576.968H1184.34V589.683H1193.81Z",
    fill: "#EFF7FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.34 560.279L1193.81 560.676L1193.38 545.576L1183.91 545.974L1184.34 560.279Z",
    fill: "#EFF7FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.53 532.066V544.384L1204.99 544.782V532.066H1195.53Z",
    fill: "#EFF7FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.91 530.079H1193.81L1193.38 515.774H1184.34L1183.91 530.079Z",
    fill: "#EFF7FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1076.79,
    y: 520.94,
    width: 41.2998,
    height: 91.393,
    fill: "#75262F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9288,
    height: 74.7051,
    transform: "matrix(0.999916 0.0129959 -0.0152327 0.999884 1190.5 403.599)",
    fill: "#59544E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.02 481.043C1201.35 481.525 1196.09 481.479 1187.04 480.735C1187.5 440.375 1187.76 423.276 1188.24 400.939C1197.44 401.884 1202.69 401.953 1212.22 401.247C1209.81 432.801 1209.68 450.25 1211.02 481.043Z",
    fill: "#B1535C"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 461.667L1191.68 451.003L1198.28 451.088L1198.12 461.752L1191.52 461.667Z",
    fill: "#EFF7FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.71 435.659L1199.52 448.529L1205.81 448.978L1205.71 435.736L1199.71 435.659Z",
    fill: "#EFF7FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.12 421.953L1191.94 433.72L1198.24 433.433L1198.72 422.038L1192.12 421.953Z",
    fill: "#EFF7FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.14 406.976L1200.54 420.222L1206.84 420.303L1207.04 407.065L1200.14 406.976Z",
    fill: "#EFF7FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.11 475.373L1199.29 463.606L1206.48 464.066L1206.31 475.465L1199.11 475.373Z",
    fill: "#EFF7FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.48 450.736L1199.32 461.767L1205.91 462.22L1205.77 451.184L1199.48 450.736Z",
    fill: "#EFF7FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.91 475.725L1198.09 463.958L1191.49 463.873L1191.31 475.641L1197.91 475.725Z",
    fill: "#EFF7FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.72 448.429L1198.31 448.881L1198.22 434.904L1191.62 435.187L1191.72 448.429Z",
    fill: "#EFF7FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.91 422.421L1199.74 433.82L1206.33 434.273L1206.5 422.505L1199.91 422.421Z",
    fill: "#EFF7FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.84 420.478L1198.74 420.567L1198.64 407.325L1192.34 407.244L1191.84 420.478Z",
    fill: "#EFF7FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M959.344 526.503V632.201H1023.87V526.503C999.066 520.377 984.93 520.476 959.344 526.503Z",
    fill: "#83131E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M964.938 532.066V534.053H980.425V529.682C974.387 529.747 971 530.124 964.938 532.066Z",
    fill: "#EFF7FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.23 529.682V534.053H1018.71V532.066C1013.61 530.168 1010.19 529.676 1003.23 529.682Z",
    fill: "#EFF7FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.64 534.053H983.006V529.682C990.006 528.245 993.861 528.302 1000.64 529.682V534.053Z",
    fill: "#EFF7FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M964.938 541.206H980.425V535.643H964.938V541.206Z",
    fill: "#EFF7FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M983.006 535.643V541.206H1000.64V535.643H983.006Z",
    fill: "#EFF7FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.23 535.643V541.206H1018.71V535.643H1003.23Z",
    fill: "#EFF7FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.05 612.333V620.28H1125.83V612.333H1069.05Z",
    fill: "url(#paint15_linear_396_2844)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.52 618.691V627.433H1132.93V618.691H1061.52Z",
    fill: "url(#paint16_linear_396_2844)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.42 625.843V632.598H1139.17V625.843H1054.42Z",
    fill: "url(#paint17_linear_396_2844)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.74 524.119C1064.31 521.595 1062.9 520.684 1059.58 517.364H1135.3C1131.33 519.428 1129.83 520.938 1129.28 524.119H1064.74Z",
    fill: "#61000F"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.83 605.181H1117.23L1119.38 612.333H1123.68L1125.83 605.181Z",
    fill: "#E6B5A1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.7 532.861H1120.06C1118.59 558.686 1118.57 573.306 1120.06 599.618H1122.7C1124.57 573.547 1124.59 558.924 1122.7 532.861Z",
    fill: "#E6B5A1"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.53,
    cy: 529.285,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1121.53,
    cy: 600.81,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.65 605.181H1069.05L1071.2 612.333H1075.5L1077.65 605.181Z",
    fill: "#E6B5A1"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.52 532.861H1071.88C1070.41 558.686 1070.39 573.306 1071.88 599.618H1074.52C1076.39 573.547 1076.41 558.924 1074.52 532.861Z",
    fill: "#E6B5A1"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1073.35,
    cy: 529.285,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1073.35,
    cy: 600.81,
    rx: 3.44165,
    ry: 5.16569,
    fill: "#E6B5A1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.5 472.86C1077.86 476.37 1078.63 478.624 1078.94 483.191H1115.51C1116.25 478.357 1116.87 475.862 1119.38 472.86H1075.5Z",
    fill: "#A82E38"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.02 517.364H1057.86C1065.55 506.851 1069.27 500.943 1073.35 490.343H1120.24C1124.52 501.054 1128.85 506.925 1137.02 517.364Z",
    fill: "#B7323D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.96,
    y: 392.593,
    width: 26.6728,
    height: 77.8827,
    fill: "#59544E"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.23 474.449C1094.09 475.104 1101.65 475.127 1114.65 474.449C1114.86 430.838 1114.85 412.362 1114.65 388.221C1101.43 389.115 1093.9 389.117 1080.23 388.221C1083.02 422.346 1082.83 441.199 1080.23 474.449Z",
    fill: "#B1535C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.63 453.786V442.263H1099.16V453.786H1108.63Z",
    fill: "#EFF7FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.44 425.573V439.481L1088.41 439.878L1088.84 425.573H1097.44Z",
    fill: "#EFF7FF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.63 410.871V423.587L1099.59 423.189L1099.16 410.871H1108.63Z",
    fill: "#EFF7FF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.44 394.579L1096.58 408.884H1087.55V394.579H1097.44Z",
    fill: "#EFF7FF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.44 468.488V455.773L1087.12 456.17V468.488H1097.44Z",
    fill: "#EFF7FF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.44 441.865V453.786L1087.98 454.183L1088.41 442.263L1097.44 441.865Z",
    fill: "#EFF7FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.16 468.886V456.17H1108.63V468.886H1099.16Z",
    fill: "#EFF7FF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.63 439.481L1099.16 439.878L1099.59 424.779L1109.06 425.176L1108.63 439.481Z",
    fill: "#EFF7FF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.44 411.268V423.587L1087.98 423.984V411.268H1097.44Z",
    fill: "#EFF7FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.06 409.282H1099.16L1099.59 394.977H1108.63L1109.06 409.282Z",
    fill: "#EFF7FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.1,
    y: 565.047,
    width: 25.8124,
    height: 43.7097,
    fill: "#5D2022"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.1,
    y: 524.516,
    width: 25.8124,
    height: 32.5836,
    fill: "#5D2022"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.69 632.598V638.956H1143.47V632.598H1049.69Z",
    fill: "url(#paint18_linear_396_2844)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M677.711 449.812H516.814L534.453 254.708H706.535L677.711 449.812Z",
    fill: "#AF8D9E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M559.404 632.996H698.791V449.812H544.777L559.404 632.996Z",
    fill: "#745C6A"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M921.639 632.599H782.252V425.176H936.266L921.639 632.599Z",
    fill: "#633D53"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M802.322 428.355H963.584L945.906 195.502H773.433L802.322 428.355Z",
    fill: "#855E6D"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M766.764 9.93408L659.213 417.626L693.629 654.056H826.133L867.863 417.626L766.764 9.93408Z",
    fill: "#40273E"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M665.236 418.421L649.318 414.845L766.765 0L877.758 414.845L863.131 418.421L766.765 17.8812L665.236 418.421Z",
    fill: "#2D062D"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.322,
    cy: 233.251,
    rx: 25.8124,
    ry: 23.8416,
    fill: "#39495E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 743.533,
    y: 296.829,
    width: 38.7185,
    height: 128.745,
    fill: "#825473"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 745.254,
    y: 524.914,
    width: 36.1373,
    height: 96.1613,
    fill: "#AB7589"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M750.416 485.575C749.174 505.616 746.235 516.551 737.94 535.642H788.705C780.985 518.354 778.495 507.47 777.95 485.575H750.416Z",
    fill: "#825473"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M548.22 364.335L551.221 402.924H588.239L591.24 364.335L572.898 296.431L548.22 364.335Z",
    fill: "#7C6472"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M601.565 364.733L604.567 403.322H641.585L644.586 364.733L626.244 296.829L601.565 364.733Z",
    fill: "#7C6472"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 698.791,
    y: 509.019,
    width: 21.5103,
    height: 77.8827,
    fill: "#825473"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 558.975,
    y: 353.651,
    width: 21.5103,
    height: 33.3783,
    fill: "#D88DB3"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 612.32,
    y: 353.651,
    width: 21.5103,
    height: 33.3783,
    fill: "#D88DB3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M578.334 490.078C578.334 479.032 587.288 470.078 598.334 470.078H620.284C631.329 470.078 640.284 479.032 640.284 490.078V632.996H578.334V490.078Z",
    fill: "#40273E"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 806.344,
    y: 509.019,
    width: 21.5103,
    height: 77.8827,
    fill: "#825473"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 877.758,
    y: 485.972,
    width: 21.5103,
    height: 77.8827,
    fill: "#825473"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 609.309,
    y: 114.043,
    width: 22.3707,
    height: 140.666,
    fill: "#40273E"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 600.705,
    y: 91.7905,
    width: 38.7185,
    height: 22.2522,
    fill: "#40273E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 585.217,
    y: 76.6909,
    width: 70.5538,
    height: 15.0997,
    fill: "#40273E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 600.705,
    y: 49.6699,
    width: 6.02288,
    height: 28.61,
    fill: "#40273E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 614.471,
    y: 58.4121,
    width: 6.02288,
    height: 19.868,
    fill: "#40273E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 736.649,
    y: 621.075,
    width: 53.3455,
    height: 8.74194,
    fill: "url(#paint19_linear_396_2844)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 729.767,
    y: 629.817,
    width: 67.1121,
    height: 8.74194,
    fill: "url(#paint20_linear_396_2844)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 723.743,
    y: 638.559,
    width: 78.2975,
    height: 8.74194,
    fill: "url(#paint21_linear_396_2844)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 717.721,
    y: 647.301,
    width: 90.3432,
    height: 8.74194,
    fill: "url(#paint22_linear_396_2844)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M544.777 361.598L548.219 364.38L572.741 302.392L591.24 364.38L595.111 361.598L572.741 294.444L544.777 361.598Z",
    fill: "#633D53"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M598.123 362.393L601.565 365.175L626.086 303.186L644.585 365.175L648.457 362.393L626.086 295.239L598.123 362.393Z",
    fill: "#633D53"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 300.802,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 315.902,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 331.002,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 346.102,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 361.201,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 376.301,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 391.4,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 746.114,
    y: 406.5,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 300.802,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 315.902,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 331.002,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 346.102,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 361.201,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 376.301,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 391.4,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 758.16,
    y: 406.5,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 300.802,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 315.902,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 331.002,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 346.102,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 361.201,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 376.301,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 391.4,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 770.206,
    y: 406.5,
    width: 9.46453,
    height: 12.7155,
    fill: "#9AAFA4"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 700.942,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 707.12,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 713.297,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 808.494,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 814.672,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 511.801,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 520.921,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 530.042,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 539.163,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 548.283,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 557.404,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 566.524,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 820.85,
    y: 575.645,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 488.754,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 497.875,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 506.995,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 516.116,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 525.236,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 534.357,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 543.478,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 879.908,
    y: 552.598,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 488.754,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 497.875,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 506.995,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 516.116,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 525.236,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 534.357,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 543.478,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 886.086,
    y: 552.598,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 488.754,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 497.875,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 506.995,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 516.116,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 525.236,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 534.357,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 543.478,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 892.262,
    y: 552.598,
    width: 4.85361,
    height: 7.68053,
    fill: "#9AAFA4"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 628.227,
    width: 52.4851,
    height: 4.76833,
    fill: "url(#paint23_linear_396_2844)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 621.075,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint24_linear_396_2844)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 609.154,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint25_linear_396_2844)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 597.233,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint26_linear_396_2844)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 585.312,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint27_linear_396_2844)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 573.392,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint28_linear_396_2844)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 561.471,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint29_linear_396_2844)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 549.55,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint30_linear_396_2844)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 537.629,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint31_linear_396_2844)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 525.708,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint32_linear_396_2844)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 513.787,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint33_linear_396_2844)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 501.867,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint34_linear_396_2844)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 583.496,
    y: 489.946,
    width: 52.4851,
    height: 11.9208,
    fill: "url(#paint35_linear_396_2844)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M583.496 489.946C583.496 483.362 588.833 478.025 595.417 478.025H624.06C630.644 478.025 635.981 483.362 635.981 489.946H583.496Z",
    fill: "url(#paint36_linear_396_2844)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M762.784 216.771C763.04 215.768 764.465 215.768 764.721 216.771L766.603 224.124C766.776 224.798 767.566 225.094 768.139 224.7L774.686 220.193C775.553 219.596 776.634 220.57 776.131 221.494L772.628 227.927C772.277 228.573 772.719 229.365 773.453 229.404L781.23 229.818C782.301 229.875 782.543 231.349 781.546 231.746L774.508 234.545C773.812 234.822 773.656 235.737 774.221 236.229L779.799 241.084C780.602 241.783 779.902 243.086 778.875 242.802L771.226 240.682C770.538 240.491 769.877 241.063 769.967 241.772L770.901 249.111C771.032 250.143 769.697 250.665 769.094 249.817L764.567 243.452C764.169 242.891 763.336 242.891 762.938 243.452L758.411 249.817C757.808 250.665 756.473 250.143 756.604 249.111L757.538 241.772C757.628 241.063 756.967 240.491 756.279 240.682L748.63 242.802C747.604 243.086 746.903 241.783 747.706 241.084L753.284 236.229C753.849 235.737 753.693 234.822 752.997 234.545L745.959 231.746C744.962 231.349 745.204 229.875 746.275 229.818L754.052 229.404C754.786 229.365 755.228 228.573 754.877 227.927L751.374 221.494C750.871 220.57 751.953 219.596 752.819 220.193L759.366 224.7C759.939 225.094 760.73 224.798 760.902 224.124L762.784 216.771Z",
    fill: "#AB7589"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 561.556,
    y: 355.241,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 561.556,
    y: 363.188,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 561.556,
    y: 371.135,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 561.556,
    y: 379.083,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 571.021,
    y: 355.241,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 571.021,
    y: 363.188,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 571.021,
    y: 371.135,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 571.021,
    y: 379.083,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 614.901,
    y: 355.241,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 614.901,
    y: 363.188,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 614.901,
    y: 371.135,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 614.901,
    y: 379.083,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 624.366,
    y: 355.241,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 624.366,
    y: 363.188,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 624.366,
    y: 371.135,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 624.366,
    y: 379.083,
    width: 6.8833,
    height: 5.56305,
    fill: "#BAE0D5"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 750.847,
    y: 535.642,
    width: 25.8124,
    height: 39.7361,
    fill: "#855265"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 750.847,
    y: 580.941,
    width: 25.8124,
    height: 40.5308,
    fill: "#855265"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M448.711 641.34L441.099 596.041L448.711 585.71L460.13 596.041L459.323 607.565L466.951 608.757L466.473 601.207L474.086 592.067L480.43 600.412L479.475 612.73H483.966L483.602 601.207L488.676 593.657L492.483 600.412L492.945 610.346L497.458 608.757L496.923 596.041L505.805 590.875L511.514 596.041L510.713 610.346L515.954 611.936V614.717H510.468L508.976 641.34H498.826L497.591 611.936L493.056 612.73L494.386 641.34H484.87L484.079 616.306H479.198L477.258 641.34H469.011L467.252 613.525L458.961 612.73L456.958 641.34H448.711Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.88 648.493L1161.26 603.194L1168.88 592.862L1180.29 603.194L1179.49 614.717L1187.12 615.909L1186.64 608.359L1194.25 599.22L1200.59 607.565L1199.64 619.883H1204.13L1203.77 608.359L1208.84 600.81L1212.65 607.565L1213.11 617.499L1217.62 615.909L1217.09 603.194L1225.97 598.028L1231.68 603.194L1230.88 617.499L1236.12 619.088V621.87H1230.63L1229.14 648.493H1218.99L1217.76 619.088L1213.22 619.883L1214.55 648.493H1205.04L1204.24 623.459H1199.36L1197.42 648.493H1189.18L1187.42 620.678L1179.13 619.883L1177.12 648.493H1168.88Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M589.819 642.135L582.206 596.836L589.819 586.505L601.237 596.836L600.43 608.36L608.058 609.552L607.581 602.002L615.193 592.863L621.537 601.207L620.582 613.525H625.073L624.709 602.002L629.784 594.452L633.59 601.207L634.052 611.141L638.565 609.552L638.031 596.836L646.912 591.671L652.621 596.836L651.82 611.141L657.062 612.731V615.512H651.575L650.084 642.135H639.934L638.699 612.731L634.163 613.525L635.493 642.135H625.978L625.186 617.102H620.305L618.365 642.135H610.118L608.36 614.32L600.069 613.525L598.065 642.135H589.819Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.99 649.288L1302.38 603.989L1309.99 593.657L1321.41 603.989L1320.6 615.512L1328.23 616.704L1327.75 609.154L1335.36 600.015L1341.71 608.36L1340.75 620.678H1345.24L1344.88 609.154L1349.95 601.604L1353.76 608.36L1354.22 618.294L1358.73 616.704L1358.2 603.989L1367.08 598.823L1372.79 603.989L1371.99 618.294L1377.23 619.883V622.665H1371.74L1370.25 649.288H1360.1L1358.87 619.883L1354.33 620.678L1355.66 649.288H1346.15L1345.36 624.254H1340.47L1338.53 649.288H1330.29L1328.53 621.472L1320.24 620.678L1318.23 649.288H1309.99Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M520.125 641.34L512.513 596.041L520.125 585.71L531.544 596.041L530.737 607.565L538.365 608.757L537.888 601.207L545.5 592.067L551.844 600.412L550.889 612.73H555.38L555.016 601.207L560.091 593.657L563.897 600.412L564.359 610.346L568.872 608.757L568.337 596.041L577.219 590.875L582.928 596.041L582.127 610.346L587.369 611.936V614.717H581.882L580.39 641.34H570.24L569.005 611.936L564.47 612.73L565.8 641.34H556.284L555.493 616.306H550.612L548.672 641.34H540.425L538.666 613.525L530.375 612.73L528.372 641.34H520.125Z",
    fill: "#E4E4E4"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.29 648.493L1232.68 603.194L1240.29 592.862L1251.71 603.194L1250.91 614.717L1258.53 615.909L1258.06 608.359L1265.67 599.22L1272.01 607.565L1271.06 619.883H1275.55L1275.18 608.359L1280.26 600.81L1284.07 607.565L1284.53 617.499L1289.04 615.909L1288.51 603.194L1297.39 598.028L1303.1 603.194L1302.3 617.499L1307.54 619.088V621.87H1302.05L1300.56 648.493H1290.41L1289.17 619.088L1284.64 619.883L1285.97 648.493H1276.45L1275.66 623.459H1270.78L1268.84 648.493H1260.59L1258.84 620.678L1250.54 619.883L1248.54 648.493H1240.29Z",
    fill: "#E4E4E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_396_2844",
    x: -347,
    y: 632,
    width: 2362,
    height: 304.836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.285744 0 0 0 0 0.480731 0 0 0 0 0.489333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_396_2844"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_396_2844",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_2844",
    x1: 2015,
    y1: 632,
    x2: 2015,
    y2: 926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB8931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99460B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_2844",
    x1: 1660.32,
    y1: 628.322,
    x2: 1660.32,
    y2: 676.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CBD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92DD5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_2844",
    x1: 1660.32,
    y1: 628.322,
    x2: 1660.32,
    y2: 676.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CBD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92DD5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_2844",
    x1: 360.231,
    y1: 613.128,
    x2: 360.231,
    y2: 621.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_2844",
    x1: 360.017,
    y1: 619.486,
    x2: 360.017,
    y2: 628.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_2844",
    x1: 359.586,
    y1: 626.638,
    x2: 359.586,
    y2: 633.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_396_2844",
    x1: 359.371,
    y1: 633.393,
    x2: 359.371,
    y2: 639.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_396_2844",
    x1: 53.4825,
    y1: 613.128,
    x2: 53.4825,
    y2: 621.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_396_2844",
    x1: 53.2676,
    y1: 619.486,
    x2: 53.2676,
    y2: 628.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_396_2844",
    x1: 52.8372,
    y1: 626.638,
    x2: 52.8372,
    y2: 633.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_396_2844",
    x1: 52.6219,
    y1: 633.393,
    x2: 52.6219,
    y2: 639.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_396_2844",
    x1: 1405.19,
    y1: 613.128,
    x2: 1405.19,
    y2: 621.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_396_2844",
    x1: 1404.98,
    y1: 619.486,
    x2: 1404.98,
    y2: 628.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_396_2844",
    x1: 1404.55,
    y1: 626.638,
    x2: 1404.55,
    y2: 633.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_396_2844",
    x1: 1404.33,
    y1: 633.393,
    x2: 1404.33,
    y2: 639.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_396_2844",
    x1: 1097.44,
    y1: 612.333,
    x2: 1097.44,
    y2: 620.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_396_2844",
    x1: 1097.22,
    y1: 618.691,
    x2: 1097.22,
    y2: 627.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_396_2844",
    x1: 1096.8,
    y1: 625.843,
    x2: 1096.8,
    y2: 632.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_396_2844",
    x1: 1096.58,
    y1: 632.598,
    x2: 1096.58,
    y2: 638.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706731,
    stopColor: "#9C7C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D5E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_396_2844",
    x1: 763.322,
    y1: 621.075,
    x2: 763.322,
    y2: 629.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51314E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_396_2844",
    x1: 763.323,
    y1: 629.817,
    x2: 763.323,
    y2: 638.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51314E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_396_2844",
    x1: 762.892,
    y1: 638.559,
    x2: 762.892,
    y2: 647.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51314E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_396_2844",
    x1: 762.892,
    y1: 647.301,
    x2: 762.892,
    y2: 656.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51314E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_396_2844",
    x1: 609.739,
    y1: 628.227,
    x2: 609.739,
    y2: 632.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_396_2844",
    x1: 609.739,
    y1: 621.075,
    x2: 609.739,
    y2: 632.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_396_2844",
    x1: 609.739,
    y1: 609.154,
    x2: 609.739,
    y2: 621.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_396_2844",
    x1: 609.739,
    y1: 597.233,
    x2: 609.739,
    y2: 609.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_396_2844",
    x1: 609.739,
    y1: 585.312,
    x2: 609.739,
    y2: 597.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_396_2844",
    x1: 609.739,
    y1: 573.392,
    x2: 609.739,
    y2: 585.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_396_2844",
    x1: 609.739,
    y1: 561.471,
    x2: 609.739,
    y2: 573.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_396_2844",
    x1: 609.739,
    y1: 549.55,
    x2: 609.739,
    y2: 561.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_396_2844",
    x1: 609.739,
    y1: 537.629,
    x2: 609.739,
    y2: 549.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_396_2844",
    x1: 609.739,
    y1: 525.708,
    x2: 609.739,
    y2: 537.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_396_2844",
    x1: 609.739,
    y1: 513.787,
    x2: 609.739,
    y2: 525.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_396_2844",
    x1: 609.739,
    y1: 501.867,
    x2: 609.739,
    y2: 513.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_396_2844",
    x1: 609.739,
    y1: 489.946,
    x2: 609.739,
    y2: 501.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_396_2844",
    x1: 609.739,
    y1: 478.025,
    x2: 609.739,
    y2: 489.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925679"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.efd6a20d009facf5c86f134c342ee1e4.svg";
export { ForwardRef as ReactComponent };